/**
 * Function for loading dynamic web components (Url only known at runtime)
 * @param {string} url - The URL of the web component
 * @param {string} nonce - The random nonce value to use for CSP
 * @param {boolean} module - Flag to indicate if the web component is a esm module
 * @param {boolean} script - Flag to indicate if the web component is loaded as normal script tag (e.g. feedback component)
 * */
export function loadWebComponent(url: string, nonce: string, module: boolean = false, isPureScript: boolean = false): void {
    try {
        const script = document.createElement('script');
        script.src = url;
        script.setAttribute('nonce', nonce);
        if (module) {
            script.type = 'module';
        } else if (!module && !isPureScript) {
            script.noModule = true;
        } 
        document.head.appendChild(script);
    } catch (e) {
        console.error(e);
    }
}